var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowmeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#003849"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9118 19.7691L30.9827 19.9003H31.1318H39.0156H39.3382L39.2577 19.588C38.4652 16.5131 36.8335 14.0979 34.3632 12.3555C31.9218 10.6138 28.9208 9.75 25.3754 9.75C22.4454 9.75 19.8298 10.4021 17.5355 11.7124C15.2423 12.9941 13.4438 14.8039 12.1426 17.137L12.1421 17.1379C10.8679 19.445 10.2339 22.0749 10.2339 25.021C10.2339 27.967 10.8679 30.5969 12.1421 32.9041L12.1433 32.9061C13.4446 35.211 15.2427 37.0198 17.5345 38.329L17.5377 38.3308C19.859 39.6121 22.4875 40.25 25.4171 40.25C27.8974 40.25 30.1326 39.7678 32.1175 38.7981C34.0932 37.8328 35.7217 36.5666 36.9979 34.998C38.2968 33.4355 39.2174 31.7416 39.7559 29.9169L39.7661 29.8823V29.8462V23.1748V22.9248H39.5161H23.9989H23.7489V23.1748V28.4615V28.7115H23.9989H32.6982C32.1519 30.1873 31.3284 31.3189 30.2334 32.1199L30.2334 32.1199L30.2312 32.1215C29.0858 32.9789 27.667 33.4143 25.9594 33.4143C23.454 33.4143 21.5086 32.6769 20.0916 31.2257C18.7015 29.7458 17.992 27.6884 17.992 25.021C17.992 22.5225 18.6732 20.5603 20.0115 19.1064L20.0131 19.1047C21.3505 17.6249 23.1291 16.8794 25.3754 16.8794C26.6769 16.8794 27.788 17.1383 28.7178 17.646L28.7177 17.6461L28.7253 17.6499C29.681 18.1306 30.408 18.8355 30.9118 19.7691Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowmeLogo);
export default __webpack_public_path__ + "static/media/growme-logo.4846ee99b811c19dbd3ea2f8658f85d6.svg";
export { ForwardRef as ReactComponent };